import script from "./Maintenance.vue?vue&type=script&setup=true&lang=js"
export * from "./Maintenance.vue?vue&type=script&setup=true&lang=js"

import "./Maintenance.vue?vue&type=style&index=0&id=1a6f130c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a6f130c"]])

export default __exports__